module.exports = __webpack_public_path__ + "static/media/empty-images.09fb8fec.svg";